// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e7f9b95b","977":"78a1b57f"}[chunkId] + ".chunk.js";
};